export default "__VITE_ASSET__Czc0V9Ex__"